module.exports = __webpack_public_path__ + "src/assets/th.4c4eb886.png";